import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import PageWrapper from "../../../component/home/HomeContentPage";
import * as Page from "../../../component/home/HomeContentPage";
import KoReplyQuestionWebchat from "../../../assets/images/home/reply_question_webchat_ko.png";

const ReplyQuestionInfoPage: React.FC = () => {
    const intl = useIntl();

    const gradient = useMemo(() => (
        <div className={"w-full h-full"}
             style={{
                 background: "linear-gradient(180deg, rgba(68, 26, 152, 0.27) 0%, rgba(255, 222, 139, 0.48) 90%)",
                 filter: "blur(150px)"
             }} />
    ), [])

    return (
        <PageWrapper className={"relative mt-[61px]"}>
            <div className={"order-2 lg:order-1 z-10"}>
                <Page.Heading>
                    {intl.formatMessage({id: "i0022"})}
                </Page.Heading>
                <Page.Description className={"mt-[16px]"}>
                    {intl.formatMessage({id: "i0023"})}
                </Page.Description>
                <Page.CheckList className={"mt-[40px]"}>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0024"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0025"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0026"})}
                    </Page.CheckListItem>
                </Page.CheckList>
            </div>
            <div className={"lg:mr-[40px] order-1 lg:order-2"}>
                <div className={"w-[675px] h-[628px] absolute top-[-210px] right-[-413px] rotate-[150deg]"}>
                    {gradient}
                </div>
                <img src={KoReplyQuestionWebchat} alt="Reply Question" width={320} height={557}
                     className={"shadow-[0px_54px_64px_-22px_rgba(110,102,126,0.38)] relative z-10"} />
            </div>
        </PageWrapper>
    )
}

export default ReplyQuestionInfoPage;
